import React, { useEffect, useState } from "react";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import Pagination from "src/components/Pagination/Pagination";
import { path } from "src/constants/path";
import DepartmentPopup from "../../components/Popup/DepartmentPopup";
import DepartmentControlPanel from "../../components/ControlPanel/DepartmentControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import DepartmentTable from "../../components/Table/DepartmentTable";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import {
  createDepartment,
  deleteDepartment,
  getDepartments,
  updateDepartment,
} from "src/apis/System/department.api";
import { Notify, NotifyConfirm, Toast } from "src/components/notify/Notify";

const initDepartmentData = {
  list: [],
  total_record: 0,
};

const titlePage = "Department";

const Departments = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();
  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [departmentData, setDepartmentData] = useState(initDepartmentData);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };
    getDepartments(query, (result) => {
      setDepartmentData({ ...result });
    });
  }, [endDate, limit, numberPage, page, search, startDate, status]);

  const actionAfterCreateOrUpdate = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setErrorsForm({});
  };

  const handleDelete = (departmentDelete) => {
    if (departmentDelete.employees.length) {
      Toast("warning", "Department vẫn còn nhân viên, không thể xóa");
    } else {
      NotifyConfirm("warning", "Are you delete it ?", (result) => {
        if (result.isConfirmed) {
          const departmentFilterData = departmentData.list.filter(
            (department) => department.id !== departmentDelete.id
          );

          setDepartmentData((prev) => {
            return {
              ...prev,
              list: [...departmentFilterData],
            };
          });
          Notify("success", "Deleted!");

          deleteDepartment(departmentDelete.id);
        }
      });
    }
  };

  const addOrEdit = (department, resetForm) => {
    if (!department.id) {
      createDepartment(department, (result) => {
        if (result.data?.status === 422) {
          setErrorsForm({ ...result.data.data });
        } else {
          setDepartmentData((prev) => {
            return {
              ...prev,
              list: [result, ...departmentData.list],
            };
          });
          actionAfterCreateOrUpdate(resetForm);
        }
      });
    } else {
      const infoUpdate = {
        name: department.name,
        description: department.description,
        roleIds: department.roleIds,
      };

      updateDepartment(department.id, infoUpdate, (result) => {
        if (result.data?.status === 422) {
          setErrorsForm({ ...result.data.data });
        } else {
          let recordIndex = departmentData.list.findIndex(
            (x) => x.id === department.id
          );
          departmentData.list[recordIndex] = { ...result };
          setDepartmentData((prev) => {
            return {
              ...prev,
              list: [...departmentData.list],
            };
          });
          actionAfterCreateOrUpdate(resetForm);
        }
      });
    }
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
    setErrorsForm({});
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <DepartmentPopup
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />

      <DepartmentControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </DepartmentControlPanel>

      <DepartmentTable
        permissionsAccessControl={permissionsAccessControl}
        data={departmentData.list}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.systemDepartment}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={departmentData.total_record}
      />
    </div>
  );
};

export default Departments;
